import {
    GET_ORDER_OPTION_INIT,
    GET_ORDER_OPTION_SUCCESS,
    SET_PREFERRED_WRITER_RATIO
} from "../actions/OrderOptionActions";

const initialState = {
    data: {
        academicLevel: [],
        deadlines: [],
        features: {},
        file: {
            extensions: [],
            limit: {},
            sizeMax: {},
            sizeMin: {},
        },
        freeWriterLevel: [],
        limits: {},
        paperFormat: [],
        spacing: [],
        subject: [],
        typeOfPaper: [],
        writerLevel: {},
        coefficients: {},
    },
    loading: true,
};

export default function OrderOptionsReducer(state = initialState, action) {
    switch (action.type) {
        case SET_PREFERRED_WRITER_RATIO:
            return {
                ...state,
                data: {
                    ...state.data,
                    writerLevel: {
                        ...state.data.writerLevel,
                        preferredWriter: {
                            ...state.data.writerLevel.preferredWriter,
                            ratio: action.payload,
                        }
                    }
                }
            }

        case GET_ORDER_OPTION_INIT:
            return {
                ...state,
                loading: true,
            }

        case GET_ORDER_OPTION_SUCCESS:
            return {
                ...state,
                data: {
                    ...state.data,
                    typeOfPaper: action.payload.typeOfPaper,
                    subject: action.payload.subject,
                    academicLevel: action.payload.academicLevel,
                    paperFormat: action.payload.paperFormat,
                    deadlines: action.payload.deadlines,
                    features: action.payload.features,
                    writerLevel: action.payload.writerLevel,
                    freeWriterLevel: action.payload.freeWriterLevel,
                    spacing: action.payload.spacing,
                    limits: action.payload.limits,
                    file: {
                        limit: action.payload.dependencies.limit,
                        extensions: action.payload.dependencies.extensions,
                        sizeMin: action.payload.dependencies.sizeMin,
                        sizeMax: action.payload.dependencies.sizeMax,
                    },
                    coefficients: action.payload.coefficients,
                },
                loading: false,
            }
    }

    return state;
}